/*
 * @Author: Lina
 * @Date: 2020-08-03 10:48:11
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-03 18:11:20
 */
import {Toast} from "antd-mobile";
import { trackClick } from '@/utils/util';

// 跳转快应用
export function openQuickApp(params) {
  const {qaChannel, href, nativePath} = params;
  const path = nativePath ? nativePath : `/pages/home-page?linkUrl=${encodeURIComponent(`pages/h5?url=${encodeURIComponent(href)}`)}`;
  console.log(qaChannel, href, nativePath)
  trackClick('c_click_common_88', {CHID: qaChannel, SOURCE: path})
  let quickTimer = null;
  const portalConfig = {
    quickUrl: 'hap://app/com.crgt.qa',
    quickPkg: 'com.crgt.qa',
  }

  const checkOpen = () => {
    window.onblur = function () {
      clearTimeout(quickTimer);
    };
    document.addEventListener(
      'webkitvisibilitychange',
      function () {
        clearTimeout(quickTimer);
      },
      false
    );
    document.addEventListener('visibilitychange', function () {
      clearTimeout(quickTimer);
    });
    document.addEventListener('qbrowserVisibilityChange', function () {
      clearTimeout(quickTimer);
    });
    window.addEventListener(
      'pagehide',
      function () {
        clearTimeout(quickTimer);
      },
      false
    );
  }

  const openLinkQuickApp = () => {
    const joinChannel = path.includes('?') ? `&p=${qaChannel}` : `?p=${qaChannel}`;
    const quickUrl = portalConfig.quickUrl + path + joinChannel;
    console.log('quickUrl',quickUrl)
    var ifr = document.createElement('iframe');
    ifr.src = quickUrl;
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    quickTimer = setTimeout(function () {
      document.body.removeChild(ifr);
    }, 3000);
    checkOpen(quickTimer);
  }

  const startOpenQuickApp = () => {
    
    const ua = navigator.userAgent.toLowerCase();
    const portalUtil = {
      userAgent: ua,
      isIOS: /(iphone os|ipad)/i.test(ua),
      isSamsung: /sm-/i.test(ua),
      isXiaomi: /(mi\s|redmi|mix)/i.test(ua)
    };
    if (window.channelReady && !portalUtil.isIOS) {
      channelReady((bAvailable) => {
        console.log(bAvailable, 'window.channelReady')
        if (bAvailable) {
          try {
            appRouter(portalConfig.quickPkg, path, {p: qaChannel});
          } catch (e) {
            console.log('error',e)
            openLinkQuickApp();
          }
        } else {
          console.log('bAvailable false')
          openLinkQuickApp();
        }
      })
    } else {
      return Toast.info('该机型可能不支持')
    }
  }

  startOpenQuickApp();
}
